export const FETCH = "support.attachments.FETCH";
export const FETCH_FAILED = "support.attachments.FETCH_FAILED";
export const FETCH_OK = "support.attachments.FETCH_OK";
